// src/components/CategoryGrid/CategoryGrid.js

import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import "./CategoryGrid.css";
import { useCategories } from "../../../hooks/category/useCategories";

const fallbackImageMap = {
  // Bất động sản - Thuê
  1: "/image/categorie_image/real estate  .png",
  // Xe cộ
  2: "/image/categorie_image/xeco.png",
  // Thời trang & Đồ dùng cá nhân
  3: "/image/categorie_image/fashiopn.png",
  3000: "/image/categorie_image/fashiopn.png",
  // Giải trí & Thể thao
  4: "/image/categorie_image/sport.png",
  4000: "/image/categorie_image/sport.png",
  // Đồ điện tử
  5: "/image/categorie_image/Electronics.png",
  5000: "/image/categorie_image/Electronics.png",
  // Dịch vụ & Du lịch
  6: "/image/categorie_image/services.png",
  6000: "/image/categorie_image/tourism.png",
  // Đồ ăn & Thực phẩm
  7: "/image/categorie_image/food_image.png",
  7000: "/image/categorie_image/food_image.png",
  // Đồ dùng văn phòng
  8: "/image/categorie_image/Office building.png",
  8000: "/image/categorie_image/Office building.png",
  // Tủ lạnh & Máy giặt
  9: "/image/categorie_image/Fridge.png",
  9000: "/image/categorie_image/washing machine.png",
  // Mẹ và Bé
  11: "/image/categorie_image/baby_mom.png",
  11000: "/image/categorie_image/baby_mom.png",
  // Thú cưng
  12: "/image/categorie_image/Pets.png",
  12000: "/image/categorie_image/Pets.png",
  // Gia dụng & Nội thất
  14: "/image/categorie_image/giadung.png",
  14000: "/image/categorie_image/giadung.png",
};

const CategoryGrid = () => {
  const { categories, loading, error } = useCategories();

  // Lọc ra tất cả các danh mục gốc (cấp 1) - đặt hook lên trước mọi early return
  const parentCategories = useMemo(
    () => categories.filter((cat) => cat.ParentID === null),
    [categories]
  );

  // Phân trang 10 mục / trang
  const PAGE_SIZE = 10;
  const [page, setPage] = useState(0);
  const totalPages = Math.ceil(parentCategories.length / PAGE_SIZE) || 1;
  const start = page * PAGE_SIZE;

  //dữ liệu của parent
  const visibleCategories = parentCategories.slice(start, start + PAGE_SIZE);

  const gotoPrev = () => setPage((p) => Math.max(0, p - 1));
  const gotoNext = () => setPage((p) => Math.min(totalPages - 1, p + 1));

  if (loading)
    return <div className="status-message">Đang tải danh mục...</div>;
  if (error) return <div className="status-message error">{error}</div>;

  return (
    <div>
      <div className="category-grid fade-in">
        {/* Chỉ hiển thị 10 danh mục theo trang */}
        {visibleCategories.map((category) => {
          // Ưu tiên ảnh từ API, nếu không có thì dùng fallback, cuối cùng dùng ảnh mặc định
          const imageUrl =
            category.image_link ??
            fallbackImageMap[category.CategoryID] ??
            "/image/categorie_image/market.png";

          return (
            <Link
              to={`/market/thanh-ly/${category.CategoryID}`}
              key={category.CategoryID}
              className="category-item-link"
            >
              <div className="category-item">
                <img
                  src={imageUrl}
                  alt={category.CategoryName}
                  className="category-image"
                  onError={(e) => {
                    // Nếu ảnh lỗi, dùng ảnh market.png làm fallback cuối cùng
                    if (!e.target.dataset.fallback) {
                      e.target.dataset.fallback = "true";
                      e.target.src = "/image/categorie_image/market.png";
                    }
                  }}
                />
                <p className="category-name">{category.CategoryName}</p>
              </div>
            </Link>
          );
        })}
      </div>

      {/* Điều hướng trang */}
      <div className="category-grid-nav">
        <button
          type="button"
          className="grid-nav-btn"
          onClick={gotoPrev}
          disabled={page === 0}
        >
          ← Trước
        </button>
        <span className="grid-page-indicator">
          {page + 1} / {totalPages}
        </span>
        <button
          type="button"
          className="grid-nav-btn"
          onClick={gotoNext}
          disabled={page >= totalPages - 1}
        >
          Sau →
        </button>
      </div>
    </div>
  );
};

export default CategoryGrid;
